<div class="promo-title">{{ promo.name }}</div>
<div class="coupon-row">
  <div class="key">Discount</div>
  @if (promo.percentOff) {
    <div class="value">{{ promo.percentOff }}%</div>
  }
  @if (!promo.percentOff) {
    <div class="value">{{ promo.amountOff | customCurrency }}</div>
  }
</div>
<div class="coupon-row">
  <div class="key">Duration</div>
  @if (promo.duration === 'forever') {
    <div class="value">Forever</div>
  }
  @if (promo.duration === 'repeating') {
    <div class="value">{{ promo.duration_in_months }} months</div>
  }
  @if (promo.duration === 'once') {
    <div class="value">First payment</div>
  }
</div>
@if (promo.expires) {
  <div class="coupon-row">
    <div class="key">Expires</div>
    <div class="value">{{ promo.expires | date }}</div>
  </div>
}
